import { Pipe, PipeTransform } from '@angular/core';
import { UiSummarySO, monthFilter } from '../shared/misc-classes';

@Pipe({
  name: 'subSOFilter'
})
export class saleOrderPipe implements PipeTransform {

  transform(items: Array<UiSummarySO>, search: string, revenueMonthFilter:monthFilter, manfMonthFilter:monthFilter, manfStrategyId:string): any {
    if(items == null || ((search == null || search == '') && (revenueMonthFilter == null) && 
                         (manfMonthFilter == null) && (manfStrategyId == null))) {
      return items;
    }

    return items.filter((_obj:UiSummarySO) => {
      return _obj.searchSaleOrder(search, revenueMonthFilter, manfMonthFilter, manfStrategyId);
    })
  }

}
